import type {TypedUseSelectorHook} from 'react-redux';
import {useDispatch, useSelector} from 'react-redux';
import {configureStore} from '@reduxjs/toolkit';

import rootReducer from '../reducers/root-reducer';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

type AppStore = typeof store;
export type AppDispatch = AppStore['dispatch'];

// Temporarily solution to see types of store
export type AppStoreType = ReturnType<typeof rootReducer>;

/**
 * Redux doesn't seen to properly support with types which causes errors
 * Redux doc recommend to use Redux Toolkit,
 * so to use typed selector we need to update or find some other way
 * @returns useDispatch from redux without any changes
 */
export const useAppDispatch: () => AppDispatch = useDispatch;
/**
 * Redux doesn't seen to properly support with types which causes errors
 * Redux doc recommend to use Redux Toolkit,
 * so to use typed selector we need to update or find some other way
 * @returns useSelector from redux without any changes
 */
export const useAppSelector: TypedUseSelectorHook<AppStoreType> = useSelector;
